import { render, staticRenderFns } from "./RcWidgetLiveResultsAlpha1.vue?vue&type=template&id=bc8ef620&"
import script from "./RcWidgetLiveResultsAlpha1.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsAlpha1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports